import React from 'react';
import '../css/Aboutus.css';

import { motion } from "framer-motion";
import { FaBullseye, FaFileAlt, FaEye } from "react-icons/fa";

const aboutCardContent = [
  {
    title: "Our Goal",
    description:
      "Deliver premium dehydrated vegetables, natural powders, whole spices, and custom seasoning blends with 100% purity.",
    icon: <FaBullseye size={40} color="#f89b29" />,
  },
  {
    title: "Our Mission",
    description:
      "Make healthy living effortless with Nutriblend for weight management & 40+ age wellness, alongside farm-fresh dehydrated produce.",
    icon: <FaFileAlt size={40} color="#f89b29" />,
  },
  {
    title: "Our Vision",
    description:
      "Become a globally recognized brand for natural, chemical-free food products celebrating authentic flavors.",
    icon: <FaEye size={40} color="#f89b29" />,
  },
];

const Aboutushome = () => {
  return (
    <>
      <div className="aboutus-container">
        <motion.div
          className="row position-relative py-2 my-2 overflow-hidden"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="row justify-content-end">
            <div className="col-lg-9">
              <motion.div
                className="card border-0 p-4 p-md-5 about-card-3d"
                initial={{ scale: 0.95 }}
                whileInView={{ scale: 1 }}
                style={{
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(245,245,245,0.95) 100%)',
                  borderRadius: '20px',
                  boxShadow: '0 -4px 10px rgba(0, 0, 0, 0.15), 4px 0 10px rgba(0, 0, 0, 0.1), -4px 0 10px rgba(0, 0, 0, 0.1)',
                  zIndex: 1,
                  position: 'relative'
                }}
              >
                <div className="position-absolute top-0 end-0 bg-primary" style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '0 20px 0 100px',
                  opacity: 0.1
                }}></div>

                <div className="position-absolute bottom-0 start-0 bg-info" style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '0 100px 0 20px',
                  opacity: 0.1
                }}></div>

                <div className="position-relative">
                  <div className="text-center mb-3">
                    <h2 className="fw-bold display-6 text-gradient">
                      <span className="position-relative" style={{ color: 'rgb(2, 58, 58)' }}>
                        Who We Are
                        <span className="position-absolute bottom-0 start-50 translate-middle-x bg-primary"
                          style={{
                            height: '4px',
                            width: '80px',
                            borderRadius: '2px'
                          }}></span>
                      </span>
                    </h2>
                  </div>

                  <p className="card-text fs-7 text-dark" style={{ lineHeight: '1.5', textAlign: "left" }}>
                    <span className="d-block fw-bold mb-3 text-primary" style={{ textAlign: "center" }}>Terra Gold</span>
                    TerraGold is a premium nutraceutical manufacturer delivering high-quality organic and plant-based wellness products using nature's finest ingredients.
                  </p>

                  <p className="card-text fs-7 text-dark" style={{ lineHeight: '1.5', textAlign: "left" }}>
                    Founded in 2019, we've grown from a simple vision into a trusted nutraceutical manufacturer, expanding our capabilities and earning customer trust through quality, integrity, and natural nutrition.
                  </p>

                  <motion.div
                    className="position-absolute d-none d-lg-block bg-white shadow-sm rounded-pill p-2 px-3"
                    style={{ top: '-30px', right: '30px', zIndex: 2 }}
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    <span className="fw-bold text-primary">Since 2019</span>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
        <br></br>

        <div className="row justify-content-center">
          <motion.div
            className="row justify-content-center"
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            {aboutCardContent.map((card, idx) => (
              <div className="col-md-4 d-flex justify-content-center" key={idx}>
                <div className="aboutus-card-container">
                  <div className="aboutus-flip-card">
                    <div className="aboutus-card-front">
                      <div className="text-center position-relative">
                        <div className="rotating-wrapper">
                          <div className="ball"></div>
                          <div className="ball1"></div>
                          <div className="ball2 d-flex justify-content-center align-items-center">
                            {card.icon}
                          </div>
                        </div>
                        <p className="aboutus-card-title">{card.title}</p>
                      </div>
                    </div>
                    <div className="aboutus-card-back">
                      <p className="aboutus-card-heading">{card.title}</p>
                      <p style={{ textAlign: "left" }}>{card.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Aboutushome;